import { useQuery } from 'react-query';
import { useAxios } from 'shared/hooks';
export var useErxNotifications = function (enabled) {
    var axios = useAxios();
    return useQuery('erx-notifications', function () { return axios.get("/api/v1/erx/notifications"); }, {
        select: function (response) { var _a; return (_a = response === null || response === void 0 ? void 0 : response.data) === null || _a === void 0 ? void 0 : _a.data; },
        enabled: enabled,
    });
};
